/**
 * tdesign v0.3.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { useRef } from 'react';

function useInitialized(check) {
  var initializedRef = useRef(check);
  if (check) {
    initializedRef.current = true;
  }
  return !!initializedRef.current;
}

export { useInitialized };
//# sourceMappingURL=useInitialized.js.map
